import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useGetUpdateUrl } from "../../hooks/useCrm";
import { useEffect } from "react";
import { InputField1 } from "../InputField1/InputField1";
const initValue = {
  Count: null,
  IdUrlLog: null,
  UrlAddress: null,
};
export const UpdateUrlItem = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initValue);
  const { mutateAsync: updateUrl } = useGetUpdateUrl();
  const handleUpdate = async (data) => {
    console.log(data);
    await updateUrl({ IdUrlLog: data });
  };
  useEffect(() => {
    setForm({
      ...form,
      Count: item?.Count,
      IdUrlLog: item?.IdUrlLog,
      UrlAddress: item?.UrlAddress,
    });
  }, [item]);
  return (
    <BootstrapModal
      modaltitle="حذف یادداشت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <InputField1
            placeholder="بازدید"
            value={form?.Count}
            label="تعداد بازدید URL"
            onChange={(e) => setForm({ ...form, Count: e.target.value })}
          />
        </div>
        <div className="col-12">
          <InputField1
            placeholder="URL"
            value={form?.UrlAddress}
            label="URL"
            onChange={(e) => setForm({ ...form, UrlAddress: e.target.value })}
          />
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleUpdate(item?.IdUrlLog);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
